import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";
const API = "https://mocktest.bbmclasses.com/api";

export default function MockTestList() {
  const { subjectId } = useParams();
  const navigate = useNavigate();

  const [subject, setSubject] = useState({});
  const [tests, setTests] = useState([]);
  const [sectionalData, setSectionalData] = useState([]);
  const [activeTab, setActiveTab] = useState("set");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* SUBJECT INFO */
  useEffect(() => {
    axios
      .get(`${API}/get_subject.php?subject_id=${subjectId}`)
      .then(res => {
        if (res.data.success) setSubject(res.data.subject);
      });
  }, [subjectId]);

  /* MOCK / PYQ */
  useEffect(() => {
    if (activeTab === "sectional") return;

    setLoading(true);
    setError("");

    axios
      .get(`${API}/get_mocktest.php?subject_id=${subjectId}`)
      .then(res => {
        setLoading(false);
        if (res.data.success) setTests(res.data.mocktests);
        else setError("No tests available");
      })
      .catch(() => {
        setLoading(false);
        setError("Failed to load tests");
      });
  }, [subjectId, activeTab]);

  /* SECTIONAL */
  useEffect(() => {
    if (activeTab !== "sectional") return;

    setLoading(true);
    setError("");

    axios
      .get(
        `https://bbmclasses.com/objective/get_sectional_structure.php?subject_id=${subjectId}`
      )
      .then(res => {
        setLoading(false);
        if (res.data.success) setSectionalData(res.data.data);
        else setError("No sectional tests found");
      })
      .catch(() => {
        setLoading(false);
        setError("Failed to load sectional tests");
      });
  }, [subjectId, activeTab]);

  const filteredTests = tests.filter(
    t => String(t.type).toLowerCase() === activeTab
  );

  return (
   <>
      <Header />
    <main style={styles.page}>
      {/* HERO */}
      <section style={styles.hero}>
        {subject.subject_image && (
          <img
            src={subject.subject_image}
            alt={subject.subject_name}
            style={styles.heroImg}
          />
        )}
        <h1 style={styles.title}>{subject.subject_name}</h1>
        <p style={styles.subtitle}>
          Free Mock Tests • PYQ • Section-wise Practice
        </p>
      </section>

      {/* TABS */}
      <nav style={styles.tabs}>
        <Tab label="Mock Tests" active={activeTab === "set"} onClick={() => setActiveTab("set")} />
        <Tab label="Previous Year" active={activeTab === "previous"} onClick={() => setActiveTab("previous")} />
        <Tab label="Sectional" active={activeTab === "sectional"} onClick={() => setActiveTab("sectional")} />
      </nav>

      {/* CONTENT */}
      {loading && <p style={styles.info}>Loading tests…</p>}
      {error && <p style={styles.error}>{error}</p>}

      {/* MOCK / PYQ */}
      {!loading && activeTab !== "sectional" && (
        <section style={styles.grid}>
          {filteredTests.map(test => (
            <article key={test.id} style={styles.card}>
              <div style={styles.cardTitle}>{test.test_name}</div>
              <div style={styles.cardMeta}>📝 Objective Practice</div>

              <button
                style={styles.startBtn}
                onClick={() => navigate(`/mocktest/${test.id}`)}
              >
                ▶ Start Test
              </button>
            </article>
          ))}
        </section>
      )}

      {/* SECTIONAL */}
      {!loading && activeTab === "sectional" && (
        <section style={styles.sectionWrapper}>
          {sectionalData.map(section => (
            <details key={section.section_id} style={styles.sectionBox}>
              <summary style={styles.sectionTitle}>
                📘 {section.section_name}
              </summary>

              {section.chapters.map(chapter => (
                <div key={chapter.chapter_id} style={styles.chapterBox}>
                  <h4>📗 {chapter.chapter_name}</h4>

                  <div style={styles.setRow}>
                    {chapter.tests.map(test => (
                      <button
                        key={test.test_id}
                        style={styles.setBtn}
                        onClick={() =>
                          navigate(`/mocktest/${test.test_id}`)
                        }
                      >
                        {test.test_name}
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </details>
          ))}
        </section>
      )}
    </main>
    <Footer />
    </>
  );
}

/* TAB */
const Tab = ({ label, active, onClick }) => (
  <button
    onClick={onClick}
    style={{
      ...styles.tab,
      background: active
        ? "linear-gradient(135deg,#2563eb,#1d4ed8)"
        : "transparent",
      color: active ? "#fff" : "var(--text)"
    }}
  >
    {label}
  </button>
);

/* STYLES */
const styles = {
  page: {
  minHeight: "100vh",
  paddingTop: 10,     // ⬆️ Header ke niche space
  paddingBottom: 56,  // ⬇️ Footer se pehle space
  background: "rgba(255,255,255,0.08)",
  backdropFilter: "blur(8px)",
  border: "1px solid rgba(255,255,255,0.15)",
},

  hero: {
    textAlign: "center",
    padding: "22px 16px"
  },
  heroImg: {
    width: 200,
    height: 200,
    borderRadius: 18,
    objectFit: "cover",
    marginBottom: 10,
    boxShadow: "0 10px 30px rgba(0,0,0,.35)"
  },
  title: { fontSize: 22, fontWeight: 700 },
  subtitle: { opacity: 0.7, fontSize: 14 },

  tabs: {
    display: "flex",
    margin: "12px",
    padding: 4,
    borderRadius: 16,
    background: "#f5f5f5",
backdropFilter: "blur(8px)",
border: "1px solid rgba(255,255,255,0.15)",
    
  },
  tab: {
    flex: 1,
    padding: "10px 0",
    borderRadius: 12,
    border: "none",
    fontWeight: 600,
    cursor: "pointer"
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill,minmax(180px,1fr))",
    gap: 16,
    padding: 16
  },

  card: {
    padding: 16,
    borderRadius: 18,
    background:
      "linear-gradient(135deg,var(--card-start),var(--card-end))",
    border: "1px solid var(--border)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 12px 40px rgba(0,0,0,.3)"
  },

  cardTitle: {
    fontSize: 15,
    fontWeight: 700,
    marginBottom: 6
  },
  cardMeta: { fontSize: 12, opacity: 0.7 },

  startBtn: {
    marginTop: 12,
    width: "100%",
    padding: "9px 0",
    borderRadius: 12,
    border: "none",
    background:
      "linear-gradient(135deg,#22c55e,#16a34a)",
    fontWeight: 700,
    cursor: "pointer"
  },

  sectionWrapper: { padding: "0 14px" },
  sectionBox: {
    background: "var(--glass-bg)",
    borderRadius: 16,
    padding: 12,
    marginBottom: 12,
    border: "1px solid var(--border)"
  },
  sectionTitle: { fontWeight: 700, cursor: "pointer" },

  chapterBox: { marginTop: 10, paddingLeft: 6 },
  setRow: { display: "flex", flexWrap: "wrap", gap: 8 },

  setBtn: {
    padding: "6px 14px",
    borderRadius: 20,
    border: "none",
    background:
      "linear-gradient(135deg,#0d6efd,#2563eb)",
    color: "#fff",
    fontSize: 13,
    cursor: "pointer"
  },

  info: { textAlign: "center", opacity: 0.7 },
  error: { textAlign: "center", color: "#ef4444" }
};